<script>
import VDataTableSessions from "@/components/VDataTable/VDataTableSessions.vue";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";

export default {
    name: "ProjectsSessions",
    components: {
        AjaxLoad,
        VDataTableSessions,
    },
    props: {
        idProject: {
            type: String,
        },
    },
    computed: {
        isCanDblClick() {
            return !!this.idProject || null;
        },
    },
    methods: {
        onDblClickRow(e, {item}) {
            this.$router.push({
                name: 'ForumEventSession',
                params: Object.assign({}, this.$route.params, {ID_SESSION: item.ID}),
            });
        },
    },
}
</script>

<template>
    <ajax-load
        ref="ajax"
        :url="$apiUrl.getForumEventSessionsUrl($route.params)"
        v-slot="{data, resolved}"
        :transform="response => response?.data?.data"
    >
        <v-card>
            <v-data-table-sessions
                :loading="!resolved"
                :items="data?.items || []"
                :footer-props="{itemsPerPageOptions:[20]}"
                @[isCanDblClick&&`dblclick:row`]="onDblClickRow"
                @click:reload="() => $refs.ajax.load()"
                heading="Сессии"
                with-toolbar
                search
                filter
            ></v-data-table-sessions>
        </v-card>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>
